var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"ui-select-match\" ng-hide=\"$select.searchEnabled &amp;&amp; ($select.open)\"\u003E\u003C!--span.ui-select-placeholder.text-muted(ng-show='!$select.searchEnabled && ($select.isEmpty() || $select.open)') {{$select.placeholder}}--\u003E\u003Cspan class=\"ui-select-placeholder text-muted\" ng-show=\"($select.isEmpty() || $select.open)\"\u003E{{$select.placeholder}}\u003C\u002Fspan\u003E\u003Cspan ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./source/common/template/selectize/match.pug
// module id = 94
// module chunks = 0